function handleXHROpenEvent(event) {
    if (!event || !event.target || !event.target.readyState || !event.target.responseURL) {
        return;
    }

    const xhr = event.target;

    if (xhr.readyState === 4 && xhr.responseURL.indexOf('signin') !== -1 && xhr.responseURL.indexOf(gtxConstants.VHOST_URL_HOST) !== -1 && window.location.href.indexOf('/login/a2f')=== -1) {

        xhr.abort();
        location.href = xhr.responseURL;
    }
}

const originalXMLHttpRequestOpen = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function() {
    this.addEventListener('load', handleXHROpenEvent);
    this.addEventListener('error', handleXHROpenEvent);

    originalXMLHttpRequestOpen.apply(this, arguments);
};
